import { Users } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useAuth } from "@/context/AuthContext";

export default function WorkspaceFilter({ associates = [], value, onChange }) {
  const { user } = useAuth();
  if (user.role !== "admin") return null;
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-56" data-testid="workspace-filter">
        <Users className="h-4 w-4 text-[#3B185F]" />
        <SelectValue placeholder="All workspaces" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all" data-testid="workspace-option-all">All workspaces</SelectItem>
        <SelectItem value={user.id} data-testid="workspace-option-owner">My workspace</SelectItem>
        {associates.map((a) => (
          <SelectItem key={a.id} value={a.id} data-testid={`workspace-option-${a.id}`}>{a.name}'s workspace</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
